import React, { useEffect, useState } from "react";
import { getApiKey, setApiKey } from "../../services/ChatService";

/**
 * Modal nhập / lưu API key. Key được lưu vào localStorage qua ChatService.
 *
 * Props:
 *  - open: boolean — hiển thị modal
 *  - onClose: () => void
 *  - onSaved?: (key: string) => void — gọi sau khi lưu thành công
 */
function ApiKeyModal({ open, onClose, onSaved }) {
  const [value, setValue] = useState("");
  const [show, setShow] = useState(false);

  // Mỗi lần mở modal → nạp lại key hiện tại.
  useEffect(() => {
    if (open) {
      setValue(getApiKey() || "");
      setShow(false);
    }
  }, [open]);

  if (!open) return null;

  const handleSave = () => {
    const trimmed = value.trim();
    setApiKey(trimmed);
    onSaved?.(trimmed);
    onClose?.();
  };

  const handleClear = () => {
    setApiKey("");
    setValue("");
    onSaved?.("");
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 px-4"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        className="w-full max-w-md rounded-2xl bg-white shadow-xl border border-gray-200 overflow-hidden"
        style={{ animation: "pimSlideUp 0.15s ease-out" }}
      >
        <div className="px-5 py-4 border-b border-gray-100">
          <h3 className="text-base font-semibold text-gray-900">API Key</h3>
          <p className="text-xs text-gray-500 mt-0.5">
            Nhập API key của bạn. Key được lưu cục bộ trên trình duyệt (localStorage).
          </p>
        </div>

        <div className="px-5 py-4 space-y-3">
          <div className="relative">
            <input
              type={show ? "text" : "password"}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSave();
              }}
              placeholder="sk-..."
              autoFocus
              className="w-full rounded-lg border border-gray-300 px-3 py-2 pr-16 text-sm focus:outline-none focus:ring-2 focus:ring-red-400 focus:border-transparent"
            />
            <button
              type="button"
              onClick={() => setShow((s) => !s)}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-gray-500 hover:text-gray-700 px-2 py-1"
            >
              {show ? "Ẩn" : "Hiện"}
            </button>
          </div>
        </div>

        <div className="px-5 py-3 border-t border-gray-100 flex items-center justify-between gap-2">
          <button
            type="button"
            onClick={handleClear}
            className="text-sm text-gray-500 hover:text-red-600 px-2 py-1.5"
          >
            Xoá key
          </button>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={onClose}
              className="text-sm text-gray-600 hover:bg-gray-100 rounded-lg px-3 py-1.5"
            >
              Hủy
            </button>
            <button
              type="button"
              onClick={handleSave}
              className="text-sm text-white bg-red-600 hover:bg-red-700 rounded-lg px-4 py-1.5 font-medium"
            >
              Lưu
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ApiKeyModal;
